import type { Degree } from "@pdfking/math"
import type { ColorID } from "./ID"
import type { PlotFunction } from "./PlotFunction"

// Base type for common properties
export type BasePlotObject = {
  enum: PlotFunction
  layer?: string
  rotation: Degree
}

// Base type for common properties
export type ConcretePlotObject = {
  fill_color: ColorID
  stroke_color: ColorID
} & BasePlotObject
